(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7325],{

/***/ 77192:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/step/choose-monitored-device",
      function () {
        return __webpack_require__(19086);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61906);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1954);






function Index() {
    const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isOpen2, setIsOpen2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("commonAndroid");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-[#fff] Sixmd:border-t-[1px] Blds:shadow-step relative Local-step Sixmds:rounded-[10px] ".concat(!isOpen && !isOpen2 ? "" : "pb-[50px]"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-[610px] Bld:w-[90%] mx-auto",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "pt-[54px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-center text-[48px] font-[600] Bld:text-[26px] Bld:leading-[40px] leading-[54px]",
                                children: [
                                    t("Choose the device you wish to monitor"),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-center mt-[24px] text-[16px] xs:text-[14px] font-[600] w-[430px] text-[#2F343C] xs:w-[96%] mx-auto",
                                children: t("Msafely will provide you with a customized solution!")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-[30px] w-full Bld:mt-[25px] mx-auto Blds:flex Bld:grid items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: ()=>{
                                    localStorage.setItem("platform", "iOS-Cloud"), router.push("/android/step/checkout/".concat(localStorage.getItem("ProductID")));
                                },
                                className: "w-[230px] h-[220px] items-center justify-center choose-device-button Bld:h-[110px] border-[1px] border-[#12D8AB] hover:border-none rounded-[12px] Bld:rounded-[8px] flex relative z-40 hover:shadow-choose active:shadow-choose bg-ios-step bg-cover hover:bg-ios-step-1 hover:bg-[#B8F3E6]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "grid items-center justify-center mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            alt: "ios",
                                            width: 100,
                                            height: 100,
                                            src: "/images/android/ios.svg",
                                            className: "w-[64px] h-[75px] mx-auto Bld:w-[40px] Bld:h-full"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "font-[600] text-[26px] Bld:text-[19px] flex items-center justify-center text-black ml-4 mt-[20px] Bld:mt-[10px] select-none",
                                            children: [
                                                "iPhone",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                                    icon: "mingcute:right-line",
                                                    className: "text-black ml-2 w-[26px] h-[26px] Bld:w-[20px] Bld:h-[20px]"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: ()=>{
                                    localStorage.setItem("platform", "Android-Cloud"), router.push("/android/step/checkout/".concat(localStorage.getItem("ProductID")));
                                },
                                className: "w-[230px] h-[220px] Blds:ml-[24px] Bld:mt-[30px] items-center justify-center choose-device-button Bld:h-[110px] border-[1px] border-[#12D8AB] hover:border-none rounded-[12px] Bld:rounded-[8px] flex relative z-40 hover:shadow-choose bg-android-step bg-cover hover:bg-android-step-1 hover:bg-[#B8F3E6]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "grid items-center justify-center mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            alt: "ios",
                                            width: 100,
                                            height: 100,
                                            src: "/images/android/android.svg",
                                            className: "w-[64px] h-[75px] mx-auto Bld:w-[40px] Bld:h-full"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "font-[600] text-[26px] Bld:text-[19px] flex items-center justify-center text-black ml-6 mt-[20px] Bld:mt-[10px] select-none",
                                            children: [
                                                "Android",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                                                    icon: "mingcute:right-line",
                                                    className: "text-black ml-2 w-[26px] h-[26px] Bld:w-[20px] Bld:h-[20px]"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: ()=>router.push("/android/step/pricing"),
                className: "absolute right-4 top-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                    icon: "akar-icons:cross",
                    className: "w-[24px] h-[24px] text-black/40"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1954,9774,2888,179], function() { return __webpack_exec__(77192); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);